import React from 'react';
import styles from './premium-item.module.scss';
import clsx from 'clsx';
import { CheckEmptyIcon, CheckIcon, StarPremiumIcon } from '@/assets/icons';
import { Typography } from '@/ui-kit';

interface Props {
    isActive?: boolean;
    date: string;
    price: string | number;
    saving?: string;
    isPopular?: boolean;
    isProfit?: boolean;
    priceInRub?: any;
    discount?: number;
    onClick?: () => void;
}

export const PremiumItem: React.FC<Props> = ({
    isActive,
    date,
    price,
    saving,
    isPopular,
    isProfit,
    priceInRub,
    discount,
    onClick,
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={clsx(styles.premiumItem, isActive && styles.active)}>
            <div className={styles.dateBlock}>
                {isActive ? (
                    <CheckIcon
                        width={20}
                        height={20}
                        className={styles.iconCenter}
                    />
                ) : (
                    <CheckEmptyIcon
                        width={20}
                        height={20}
                        className={styles.iconCenter}
                    />
                )}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    gap: 1,
                    textAlign: 'left'
                }}>
                    <Typography
                        fontWeight="semibold"
                        fontFamily="SFProText"
                        typeColor={isActive ? 'white' : 'black'}
                        className={styles.subTitle}>
                        {date}
                    </Typography>
                    {
                        priceInRub ?
                            <span className={styles.priceInRub}>
                                {
                                    [
                                        '≈',
                                        priceInRub
                                            .toString()
                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
                                        ' ₽',
                                    ].join('')
                                }
                            </span>
                        :
                            <></>
                    }
                </div>
                {isProfit && (
                    <Typography
                        uppercase
                        className={styles.badge}
                        typeColor="white"
                        fontFamily="SFProText">
                        Выгодно
                    </Typography>
                )}
                {isPopular && (
                    <Typography
                        uppercase
                        className={styles.badge}
                        typeColor="white"
                        fontFamily="SFProText">
                        Популярный
                    </Typography>
                )}
            </div>
            <div className={styles.priceBlock}>
                <Typography
                    fontFamily="SFProText"
                    className={styles.priceText}
                    typeColor={isActive ? 'white' : 'black'}>
                    {typeof price === 'number'
                        ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                        : price}
                </Typography>
                <StarPremiumIcon
                    width={16}
                    height={16}
                />
            </div>
            {saving && <div className={styles.savingLabel}>{saving}</div>}
            {
                discount ?
                    <div className={styles.discount}>
                        {
                            [
                                '-',
                                discount,
                                '%',
                            ].join('')
                        }
                    </div>
                :
                    <></>
            }
        </button>
    );
};
